var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main_container" }, [
    _c("div", { staticClass: " container-fluid edit-story-wrapper" }, [
      _c(
        "div",
        { staticClass: "controls-sidebar", attrs: { id: "controls-sidebar" } },
        [
          _c("ul", [
            _c(
              "div",
              {
                staticClass: "toggle-sidebar",
                attrs: { id: "toggle-sidebar" },
                on: { click: _vm.toggleSidebar }
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      id: "toggle-sidebar-SVG",
                      width: "24",
                      height: "24",
                      viewBox: "0 0 47 78",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }
                  },
                  [
                    _c("line", {
                      attrs: {
                        x1: "7",
                        y1: "37.5268",
                        x2: "39.5269",
                        y2: "4.99992",
                        stroke: "white",
                        "stroke-width": "10",
                        "stroke-linecap": "round"
                      }
                    }),
                    _vm._v(" "),
                    _c("line", {
                      attrs: {
                        x1: "5",
                        y1: "-5",
                        x2: "51",
                        y2: "-5",
                        transform:
                          "matrix(-0.707107 -0.707107 -0.707107 0.707107 39.5979 77.5979)",
                        stroke: "white",
                        "stroke-width": "10",
                        "stroke-linecap": "round"
                      }
                    })
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                on: {
                  click: function($event) {
                    return _vm.addNode("Scene")
                  }
                }
              },
              [
                _c("span", { staticClass: "nav-link" }, [
                  _c("img", { attrs: { src: _vm.addScene } }),
                  _vm._v("\n              Add new scene\n            ")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                on: {
                  click: function($event) {
                    return _vm.addNode("Logic")
                  }
                }
              },
              [
                _c("span", { staticClass: "nav-link" }, [
                  _c("img", { attrs: { src: _vm.addLogic } }),
                  _vm._v("\n            Add new logic\n            ")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                on: {
                  click: function($event) {
                    return _vm.addNode("Page")
                  }
                }
              },
              [
                _c("span", { staticClass: "nav-link" }, [
                  _c("img", { attrs: { src: _vm.addPage } }),
                  _vm._v("\n            Add new page\n            ")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                on: {
                  click: function($event) {
                    return _vm.createGroup("New Group")
                  }
                }
              },
              [
                _c("span", { staticClass: "nav-link" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "35",
                        height: "35",
                        viewBox: "0 0 20 20",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
                          fill: "#E4C1F9"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M13.23 9.54105H10.459V6.77005C10.459 6.64818 10.4106 6.5313 10.3245 6.44513C10.2383 6.35896 10.1214 6.31055 9.99955 6.31055C9.87768 6.31055 9.7608 6.35896 9.67463 6.44513C9.58846 6.5313 9.54005 6.64818 9.54005 6.77005V9.54105H6.77005C6.64818 9.54105 6.5313 9.58946 6.44513 9.67563C6.35896 9.7618 6.31055 9.87868 6.31055 10.0005C6.31055 10.1224 6.35896 10.2393 6.44513 10.3255C6.5313 10.4116 6.64818 10.46 6.77005 10.46H9.54105V13.231C9.54105 13.3529 9.58946 13.4698 9.67563 13.556C9.7618 13.6421 9.87868 13.6905 10.0005 13.6905C10.1224 13.6905 10.2393 13.6421 10.3255 13.556C10.4116 13.4698 10.46 13.3529 10.46 13.231V10.459H13.231C13.3529 10.459 13.4698 10.4106 13.556 10.3245C13.6421 10.2383 13.6905 10.1214 13.6905 9.99955C13.6905 9.87768 13.6421 9.7608 13.556 9.67463C13.4698 9.58846 13.3529 9.54005 13.231 9.54005L13.23 9.54105Z",
                          fill: "#161E32"
                        }
                      })
                    ]
                  ),
                  _vm._v("\n            New group\n          ")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                on: {
                  click: function($event) {
                    return _vm.addTransition("Transition")
                  }
                }
              },
              [
                _c("span", { staticClass: "nav-link" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "35",
                        height: "35",
                        viewBox: "0 0 20 20",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
                          fill: "#85D2BD"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M8.18136 14.1011C8.12036 14.0401 8.03763 14.0058 7.95136 14.0058C7.86509 14.0058 7.78236 14.0401 7.72136 14.1011C7.66036 14.1621 7.62609 14.2448 7.62609 14.3311C7.62609 14.4174 7.66036 14.5001 7.72136 14.5611L8.08936 14.9291H6.60036C6.13419 14.9288 5.68719 14.7435 5.35756 14.4139C5.02793 14.0842 4.84262 13.6373 4.84236 13.1711V12.0811C4.84236 11.995 4.80817 11.9125 4.74732 11.8516C4.68646 11.7908 4.60392 11.7566 4.51786 11.7566C4.4318 11.7566 4.34926 11.7908 4.2884 11.8516C4.22755 11.9125 4.19336 11.995 4.19336 12.0811V13.1711C4.19362 13.8094 4.4473 14.4215 4.89865 14.8728C5.34999 15.3241 5.96206 15.5778 6.60036 15.5781H8.09236L7.72436 15.9461C7.67868 15.9914 7.64753 16.0493 7.63488 16.1124C7.62223 16.1755 7.62865 16.2409 7.65332 16.3003C7.67799 16.3597 7.7198 16.4105 7.77341 16.446C7.82702 16.4816 7.89002 16.5004 7.95436 16.5001C8.04049 16.4997 8.12303 16.4656 8.18436 16.4051L9.10636 15.4831C9.1366 15.4529 9.16058 15.417 9.17695 15.3776C9.19332 15.3381 9.20174 15.2958 9.20174 15.2531C9.20174 15.2104 9.19332 15.168 9.17695 15.1286C9.16058 15.0891 9.1366 15.0533 9.10636 15.0231L8.18136 14.1011Z",
                          fill: "#161E32"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M9.8708 4.27808H4.5408C4.45495 4.27834 4.37269 4.31256 4.31199 4.37326C4.25128 4.43397 4.21706 4.51623 4.2168 4.60208V9.93208C4.21785 10.0174 4.25241 10.0989 4.31303 10.159C4.37365 10.219 4.45546 10.2528 4.5408 10.2531H9.8708C9.95665 10.2528 10.0389 10.2186 10.0996 10.1579C10.1603 10.0972 10.1945 10.0149 10.1948 9.92908V4.60208C10.1948 4.51615 10.1607 4.43374 10.0999 4.37297C10.0391 4.31221 9.95673 4.27808 9.8708 4.27808ZM9.5468 9.60808H4.8658V4.92708H9.5468V9.60808Z",
                          fill: "#161E32"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M13.989 5.19999H12.496L12.864 4.83199C12.9162 4.7694 12.943 4.6895 12.9391 4.6081C12.9351 4.52671 12.9007 4.44976 12.8427 4.39252C12.7847 4.33527 12.7074 4.30191 12.6259 4.29903C12.5445 4.29615 12.4649 4.32398 12.403 4.37699L11.484 5.29899C11.4538 5.32917 11.4298 5.36502 11.4135 5.40449C11.3971 5.44396 11.3887 5.48626 11.3887 5.52899C11.3887 5.57171 11.3971 5.61402 11.4135 5.65348C11.4298 5.69295 11.4538 5.7288 11.484 5.75899L12.406 6.68099C12.4671 6.74182 12.5498 6.77598 12.636 6.77599C12.7222 6.77555 12.8047 6.74145 12.8661 6.68099C12.8963 6.6508 12.9203 6.61495 12.9366 6.57548C12.953 6.53602 12.9614 6.49371 12.9614 6.45099C12.9614 6.40826 12.953 6.36596 12.9366 6.32649C12.9203 6.28702 12.8963 6.25117 12.8661 6.22099L12.498 5.85299H13.9911C14.4572 5.85325 14.9042 6.03855 15.2339 6.36819C15.5635 6.69782 15.7488 7.14482 15.7491 7.61099V8.70099C15.7491 8.78705 15.7832 8.86959 15.8441 8.93044C15.9049 8.9913 15.9875 9.02549 16.0735 9.02549C16.1596 9.02549 16.2422 8.9913 16.303 8.93044C16.3639 8.86959 16.398 8.78705 16.398 8.70099V7.60599C16.3967 6.96776 16.1424 6.3561 15.6908 5.90509C15.2393 5.45408 14.6273 5.20051 13.989 5.19999Z",
                          fill: "#161E32"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M16.0506 15.8511C16.008 15.8509 15.9658 15.8593 15.9264 15.8755C15.8871 15.8917 15.8513 15.9156 15.8212 15.9457C15.7911 15.9758 15.7672 16.0116 15.751 16.0509C15.7347 16.0903 15.7264 16.1325 15.7266 16.1751C15.7273 16.2611 15.7614 16.3436 15.8216 16.4051C15.8826 16.4661 15.9653 16.5003 16.0516 16.5003C16.1378 16.5003 16.2206 16.4661 16.2816 16.4051C16.3426 16.3441 16.3768 16.2613 16.3768 16.1751C16.3768 16.0888 16.3426 16.0061 16.2816 15.9451C16.2194 15.8853 16.1368 15.8517 16.0506 15.8511Z",
                          fill: "#161E32"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M14.7166 15.8511C14.6525 15.8511 14.5899 15.8701 14.5366 15.9057C14.4833 15.9413 14.4418 15.9919 14.4172 16.0511C14.3927 16.1103 14.3863 16.1754 14.3988 16.2383C14.4113 16.3011 14.4422 16.3589 14.4875 16.4042C14.5328 16.4495 14.5905 16.4804 14.6534 16.4929C14.7162 16.5054 14.7814 16.4989 14.8406 16.4744C14.8998 16.4499 14.9504 16.4084 14.986 16.3551C15.0216 16.3018 15.0406 16.2392 15.0406 16.1751C15.0403 16.0892 15.0061 16.007 14.9454 15.9463C14.8847 15.8856 14.8024 15.8513 14.7166 15.8511Z",
                          fill: "#161E32"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M12.0506 15.8511C11.9865 15.8511 11.9238 15.8701 11.8706 15.9057C11.8173 15.9413 11.7758 15.9919 11.7512 16.0511C11.7267 16.1103 11.7203 16.1754 11.7328 16.2383C11.7453 16.3011 11.7762 16.3589 11.8215 16.4042C11.8668 16.4495 11.9245 16.4804 11.9874 16.4929C12.0502 16.5054 12.1154 16.4989 12.1746 16.4744C12.2338 16.4499 12.2844 16.4084 12.32 16.3551C12.3556 16.3018 12.3746 16.2392 12.3746 16.1751C12.3743 16.0892 12.3401 16.007 12.2794 15.9463C12.2187 15.8856 12.1364 15.8513 12.0506 15.8511Z",
                          fill: "#161E32"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M13.3846 15.8511C13.3205 15.8511 13.2578 15.8701 13.2045 15.9057C13.1512 15.9413 13.1097 15.9919 13.0852 16.0511C13.0607 16.1103 13.0543 16.1754 13.0668 16.2383C13.0793 16.3011 13.1101 16.3589 13.1554 16.4042C13.2007 16.4495 13.2585 16.4804 13.3213 16.4929C13.3842 16.5054 13.4493 16.4989 13.5085 16.4744C13.5677 16.4499 13.6183 16.4084 13.6539 16.3551C13.6895 16.3018 13.7085 16.2392 13.7085 16.1751C13.7083 16.0892 13.674 16.007 13.6133 15.9463C13.5526 15.8856 13.4704 15.8513 13.3846 15.8511Z",
                          fill: "#161E32"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M10.7205 15.8511C10.6779 15.8509 10.6357 15.8593 10.5963 15.8755C10.557 15.8917 10.5212 15.9156 10.4911 15.9457C10.461 15.9758 10.4371 16.0116 10.4209 16.0509C10.4046 16.0903 10.3964 16.1325 10.3965 16.1751C10.3972 16.2611 10.4313 16.3436 10.4915 16.4051C10.5527 16.4657 10.6353 16.4999 10.7215 16.5001C10.8076 16.4994 10.89 16.4654 10.9515 16.4051C11.0123 16.344 11.0464 16.2613 11.0464 16.1751C11.0464 16.0889 11.0123 16.0062 10.9515 15.9451C10.8896 15.885 10.8068 15.8513 10.7205 15.8511Z",
                          fill: "#161E32"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M10.7205 14.5181C10.6564 14.5181 10.5938 14.5371 10.5405 14.5727C10.4872 14.6083 10.4457 14.6589 10.4211 14.7181C10.3966 14.7773 10.3902 14.8424 10.4027 14.9053C10.4152 14.9681 10.4461 15.0259 10.4914 15.0712C10.5367 15.1165 10.5944 15.1473 10.6573 15.1598C10.7201 15.1723 10.7853 15.1659 10.8445 15.1414C10.9037 15.1169 10.9543 15.0753 10.9899 15.0221C11.0255 14.9688 11.0445 14.9062 11.0445 14.8421C11.0442 14.7562 11.01 14.674 10.9493 14.6133C10.8886 14.5525 10.8063 14.5183 10.7205 14.5181Z",
                          fill: "#161E32"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M10.7205 13.1851C10.6565 13.1851 10.5938 13.204 10.5406 13.2396C10.4873 13.2752 10.4458 13.3257 10.4213 13.3849C10.3967 13.444 10.3902 13.5091 10.4026 13.5719C10.4151 13.6347 10.4458 13.6925 10.491 13.7378C10.5362 13.7832 10.5939 13.8141 10.6567 13.8267C10.7194 13.8393 10.7846 13.8331 10.8438 13.8087C10.903 13.7843 10.9537 13.7429 10.9894 13.6898C11.0251 13.6366 11.0443 13.5741 11.0445 13.5101C11.0445 13.424 11.0104 13.3415 10.9496 13.2806C10.8889 13.2197 10.8065 13.1853 10.7205 13.1851Z",
                          fill: "#161E32"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M10.7205 11.8521C10.6564 11.8521 10.5938 11.871 10.5405 11.9066C10.4872 11.9422 10.4457 11.9929 10.4211 12.0521C10.3966 12.1113 10.3902 12.1764 10.4027 12.2393C10.4152 12.3021 10.4461 12.3598 10.4914 12.4052C10.5367 12.4505 10.5944 12.4813 10.6573 12.4938C10.7201 12.5063 10.7853 12.4999 10.8445 12.4754C10.9037 12.4509 10.9543 12.4093 10.9899 12.356C11.0255 12.3028 11.0445 12.2401 11.0445 12.1761C11.0442 12.0902 11.01 12.0079 10.9493 11.9472C10.8886 11.8865 10.8063 11.8523 10.7205 11.8521Z",
                          fill: "#161E32"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M10.721 10.521C10.6349 10.521 10.5524 10.5552 10.4915 10.616C10.4307 10.6769 10.3965 10.7594 10.3965 10.8455C10.3965 10.9316 10.4307 11.0141 10.4915 11.075C10.5524 11.1358 10.6349 11.17 10.721 11.17C10.8071 11.1693 10.8895 11.1353 10.951 11.075C11.0116 11.0138 11.0458 10.9312 11.046 10.845C11.0452 10.7589 11.0112 10.6765 10.951 10.615C10.8897 10.5545 10.8071 10.5207 10.721 10.521Z",
                          fill: "#161E32"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M14.7166 10.521C14.6525 10.521 14.5899 10.54 14.5366 10.5756C14.4833 10.6112 14.4418 10.6618 14.4172 10.721C14.3927 10.7802 14.3863 10.8454 14.3988 10.9082C14.4113 10.9711 14.4422 11.0288 14.4875 11.0741C14.5328 11.1194 14.5905 11.1503 14.6534 11.1628C14.7162 11.1753 14.7814 11.1689 14.8406 11.1443C14.8998 11.1198 14.9504 11.0783 14.986 11.025C15.0216 10.9717 15.0406 10.9091 15.0406 10.845C15.0403 10.7591 15.0061 10.6769 14.9454 10.6162C14.8847 10.5555 14.8024 10.5213 14.7166 10.521Z",
                          fill: "#161E32"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M13.3846 10.521C13.3205 10.521 13.2578 10.54 13.2045 10.5756C13.1512 10.6112 13.1097 10.6618 13.0852 10.721C13.0607 10.7802 13.0543 10.8454 13.0668 10.9082C13.0793 10.9711 13.1101 11.0288 13.1554 11.0741C13.2007 11.1194 13.2585 11.1503 13.3213 11.1628C13.3842 11.1753 13.4493 11.1689 13.5085 11.1443C13.5677 11.1198 13.6183 11.0783 13.6539 11.025C13.6895 10.9717 13.7085 10.9091 13.7085 10.845C13.7083 10.7591 13.674 10.6769 13.6133 10.6162C13.5526 10.5555 13.4704 10.5213 13.3846 10.521Z",
                          fill: "#161E32"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M12.0506 10.521C11.9865 10.521 11.9238 10.54 11.8706 10.5756C11.8173 10.6112 11.7758 10.6618 11.7512 10.721C11.7267 10.7802 11.7203 10.8454 11.7328 10.9082C11.7453 10.9711 11.7762 11.0288 11.8215 11.0741C11.8668 11.1194 11.9245 11.1503 11.9874 11.1628C12.0502 11.1753 12.1154 11.1689 12.1746 11.1443C12.2338 11.1198 12.2844 11.0783 12.32 11.025C12.3556 10.9717 12.3746 10.9091 12.3746 10.845C12.3743 10.7591 12.3401 10.6769 12.2794 10.6162C12.2187 10.5555 12.1364 10.5213 12.0506 10.521Z",
                          fill: "#161E32"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M16.0506 10.521C15.9862 10.5208 15.9233 10.5397 15.8697 10.5753C15.8161 10.611 15.7743 10.6617 15.7495 10.7212C15.7248 10.7806 15.7183 10.846 15.7308 10.9092C15.7433 10.9723 15.7743 11.0303 15.8198 11.0758C15.8653 11.1213 15.9233 11.1523 15.9865 11.1648C16.0496 11.1773 16.115 11.1708 16.1744 11.1461C16.2339 11.1213 16.2846 11.0795 16.3203 11.0259C16.3559 10.9723 16.3748 10.9094 16.3746 10.845C16.374 10.7589 16.3399 10.6764 16.2796 10.615C16.218 10.5557 16.1361 10.5221 16.0506 10.521Z",
                          fill: "#161E32"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M16.0506 11.8521C15.9865 11.8521 15.9238 11.871 15.8706 11.9066C15.8173 11.9422 15.7758 11.9929 15.7512 12.0521C15.7267 12.1113 15.7203 12.1764 15.7328 12.2393C15.7453 12.3021 15.7762 12.3598 15.8215 12.4052C15.8668 12.4505 15.9245 12.4813 15.9874 12.4938C16.0502 12.5063 16.1154 12.4999 16.1746 12.4754C16.2338 12.4509 16.2844 12.4093 16.32 12.356C16.3556 12.3028 16.3746 12.2401 16.3746 12.1761C16.3743 12.0902 16.3401 12.0079 16.2794 11.9472C16.2187 11.8865 16.1364 11.8523 16.0506 11.8521Z",
                          fill: "#161E32"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M16.0506 14.5181C15.9865 14.5181 15.9238 14.5371 15.8706 14.5727C15.8173 14.6083 15.7758 14.6589 15.7512 14.7181C15.7267 14.7773 15.7203 14.8424 15.7328 14.9053C15.7453 14.9681 15.7762 15.0259 15.8215 15.0712C15.8668 15.1165 15.9245 15.1473 15.9874 15.1598C16.0502 15.1723 16.1154 15.1659 16.1746 15.1414C16.2338 15.1169 16.2844 15.0753 16.32 15.0221C16.3556 14.9688 16.3746 14.9062 16.3746 14.8421C16.3743 14.7562 16.3401 14.674 16.2794 14.6133C16.2187 14.5525 16.1364 14.5183 16.0506 14.5181Z",
                          fill: "#161E32"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M16.0506 13.1851C15.9865 13.1851 15.9239 13.204 15.8707 13.2396C15.8174 13.2752 15.7759 13.3257 15.7513 13.3849C15.7268 13.444 15.7203 13.5091 15.7327 13.5719C15.7451 13.6347 15.7759 13.6925 15.8211 13.7378C15.8663 13.7832 15.924 13.8141 15.9867 13.8267C16.0495 13.8393 16.1146 13.8331 16.1738 13.8087C16.2331 13.7843 16.2838 13.7429 16.3195 13.6898C16.3552 13.6366 16.3744 13.5741 16.3746 13.5101C16.3746 13.424 16.3404 13.3415 16.2797 13.2806C16.219 13.2197 16.1366 13.1853 16.0506 13.1851Z",
                          fill: "#161E32"
                        }
                      })
                    ]
                  ),
                  _vm._v("\n            New transition\n          ")
                ])
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "controls-topbar control__btns" },
        [
          _c(
            "li",
            {
              staticClass: "coming_soon",
              attrs: { title: "coming soon" },
              on: {
                click: function($event) {
                  return _vm.undo()
                }
              }
            },
            [
              _c(
                "span",
                {
                  staticClass: "nav-link",
                  class: [_vm.undoButtonIsActive ? "" : "disabled"]
                },
                [_c("img", { attrs: { src: _vm.undoSvg } })]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "coming_soon",
              attrs: { title: "coming soon" },
              on: {
                click: function($event) {
                  return _vm.redo()
                }
              }
            },
            [
              _c(
                "span",
                {
                  staticClass: "nav-link",
                  class: [_vm.redoButtonIsActive ? "" : "disabled"]
                },
                [_c("img", { attrs: { src: _vm.redoSvg } })]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              attrs: { title: "delete" },
              on: {
                click: function($event) {
                  return _vm.deleteDiagramNodes()
                }
              }
            },
            [
              _c(
                "span",
                {
                  staticClass: "nav-link",
                  class: [_vm.deleteButtonIsActive ? "" : "disabled"]
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "16",
                        height: "18",
                        viewBox: "0 0 16 18",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M2.07961 15.911C2.08172 16.4327 2.28998 16.9325 2.659 17.3013C3.02802 17.6701 3.52787 17.8782 4.04961 17.88H11.9496C12.4719 17.8789 12.9725 17.6713 13.3422 17.3024C13.7118 16.9334 13.9205 16.4332 13.9226 15.911V4.55999H2.07961V15.911ZM15.3996 1.6H11.6996L10.4606 0.119995H5.53861L4.29961 1.6H0.599609V3.08H15.3996V1.6Z",
                          fill: "#fff"
                        }
                      })
                    ]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "coming_soon",
              attrs: { title: "coming soon" },
              on: {
                click: function($event) {
                  return _vm.dublicate()
                }
              }
            },
            [
              _c(
                "span",
                {
                  staticClass: "nav-link",
                  class: [_vm.redoButtonIsActive ? "" : "disabled"]
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M9.18378 7.5509H16.5308C16.9639 7.5509 17.3792 7.72295 17.6855 8.0292C17.9917 8.33544 18.1638 8.75081 18.1638 9.1839V16.5309C18.1638 16.964 17.9917 17.3794 17.6855 17.6856C17.3792 17.9919 16.9639 18.1639 16.5308 18.1639H9.18378C8.75068 18.1639 8.33532 17.9919 8.02908 17.6856C7.72283 17.3794 7.55078 16.964 7.55078 16.5309V9.1839C7.55078 8.75081 7.72283 8.33544 8.02908 8.0292C8.33532 7.72295 8.75068 7.5509 9.18378 7.5509V7.5509Z",
                          stroke: "#fff",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M4.28494 12.4489H3.46894C3.03584 12.4489 2.62048 12.2769 2.31423 11.9706C2.00799 11.6644 1.83594 11.249 1.83594 10.8159V3.46894C1.83594 3.03584 2.00799 2.62048 2.31423 2.31423C2.62048 2.00799 3.03584 1.83594 3.46894 1.83594H10.8159C11.249 1.83594 11.6644 2.00799 11.9706 2.31423C12.2769 2.62048 12.4489 3.03584 12.4489 3.46894V4.28494",
                          stroke: "#fff",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }
                      })
                    ]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("router-link", { attrs: { to: { name: "simulation" } } }, [
            _c(
              "span",
              {
                staticClass: "nav-link",
                class: [_vm.deleteButtonIsActive ? "" : "disabled"],
                attrs: { title: "play" }
              },
              [_c("i", { staticClass: "fab fa-unity fa-xl" })]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { attrs: { id: "myDiagramDiv" } })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d3e0152", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d3e0152","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/mainStoryView.vue
// module id = null
// module chunks = 